import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { EntityDocumentTreeListComponent } from './entity-document-tree/entity-document-tree-list/entity-document-tree-list.component';
import { LayOutComponent } from './lay-out/lay-out.component';
import { MsalGuard } from '@azure/msal-angular';
import { CountryNameReminderComponent } from './country-name-reminder/country-name-reminder.component';

const routes: Routes = [
  {
    path: '',
    component: LayOutComponent,
    canActivate: [MsalGuard],
    children: [
      { path: '', component: CountryNameReminderComponent },
      { path: ':countryName', component: EntityDocumentTreeListComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
